import React, { useState } from 'react';
import { useUpdateEffect } from 'usehooks-ts';
import styled from 'styled-components';

import { Tabs } from '@lt/components';

import { SEARCH_TYPES, SEARCH_TYPE_NAMES } from 'src/constants/search';

import { SearchTypeTab } from './SearchTypeTab';

import type { SearchType } from '../../types/search';
import type { TabsVariant } from './types';
import { checkCigaretteVariant } from './utils';

interface SwitchTabsProps {
  previousSearchType: SearchType;
  searchType: SearchType;
  url: string;
  cigaretteType: 'MAIN' | 'SEARCH' | 'HOTEL' | 'OLD_MAIN';
  isMobile: boolean;
}

interface SearchTypeTabsProps {
  selectedTab: SearchType;
  variant: TabsVariant;
  setSelectedTab:
    | React.Dispatch<React.SetStateAction<SearchType>>
    | React.Dispatch<SearchType>;
  className?: string;
  availableSearchTypes?: string[];
  isMobile: boolean;
  appName?: string;
  switchTab?: (params: SwitchTabsProps) => void;
}

const SearchTypeTabs = (props: SearchTypeTabsProps) => {
  const {
    selectedTab = SEARCH_TYPE_NAMES.PACKAGE,
    setSelectedTab,
    variant,
    className,
    availableSearchTypes,
    isMobile,
    appName,
    switchTab,
  } = props;

  const [previousSelectedTab, setPreviousSelectedTab] = useState(selectedTab);

  const searchTypesArray = availableSearchTypes
    ? SEARCH_TYPES.filter(({ name }) => availableSearchTypes.includes(name))
    : SEARCH_TYPES;

  const handleTabsChange = (newSelectedTab: SearchType) => {
    setPreviousSelectedTab(selectedTab);
    setSelectedTab(newSelectedTab);
  };

  // При инициализации не должен вызываться switchTab, только при смене тип поиска
  useUpdateEffect(
    () => {
      switchTab?.({
        previousSearchType: previousSelectedTab,
        searchType: selectedTab,
        url: window.location.href,
        cigaretteType: checkCigaretteVariant(appName, variant.page),
        isMobile,
      });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [isMobile, selectedTab, switchTab, variant.page],
  );

  return searchTypesArray.length > 1 ? (
    <StyledTabs
      functional
      onChange={handleTabsChange}
      $variant={variant}
      className={className}
    >
      {searchTypesArray.map((searchTypeInfo) => (
        <SearchTypeTab
          key={searchTypeInfo.name}
          isActive={selectedTab === searchTypeInfo.name}
          {...props}
          {...searchTypeInfo}
        />
      ))}
    </StyledTabs>
  ) : null;
};

const StyledTabs = styled(Tabs)<{
  $variant: TabsVariant;
}>`
  display: flex;
  justify-content: ${({ $variant: { mobile, page } }) =>
    mobile && page === 'OLD_MAIN' ? 'center' : 'flex-start'};
  height: ${({ $variant: { collapsed } }) => (collapsed ? 20 : 40)}px;
`;

export default SearchTypeTabs;
